'use client';

import Link from 'next/link';
import { useForm } from 'react-hook-form';
import * as env from '../../shared/lib/env';
import { Button } from '../../shared/ui/Button';
import { TextField } from '../../shared/ui/TextField';
import { useSignInWithEmailPassword } from '../../shared/store/auth/mutatons';

const EmailPasswordSignInForm: React.FCC = () => {
  const signInMutation = useSignInWithEmailPassword();
  const loading = signInMutation.isMutating;

  const onSubmit = (credentials: { email: string; password: string }) => {
    signInMutation.mutate({
      username: credentials.email,
      password: credentials.password,
    });
  };

  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const emailControl = register('email', { required: true });
  const passwordControl = register('password', { required: true });

  const forgotUrl = `${env.managerAppUrl}/passwordreset?returnUrl=${env.getHostURL()}`

  return (
    <form
      className={'w-full'}
      onSubmit={handleSubmit(onSubmit)}
      data-cy="auth-sign-in-form"
    >
      <div className={'flex-col space-y-5'}>
        <TextField>
          <TextField.Label>
            Email Address
            <TextField.Input
              data-cy="email-input"
              required
              type="email"
              placeholder="Email Address"
              {...emailControl}
            />
          </TextField.Label>
          <TextField.Hint>
            The email address you use for Rentgrata.
          </TextField.Hint>
        </TextField>

        <TextField>
          <TextField.Label>
            Password
            <TextField.Input
              data-cy="password-input"
              required
              type="password"
              placeholder="Password"
              {...passwordControl}
            />
          </TextField.Label>
        </TextField>
      </div>

      <div className="pt-14">
        <Button
          className={'w-full'}
          type="submit"
          loading={loading}
          data-cy="auth-submit-button"
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </Button>
      </div>

      <div className={'text-xs ml-auto pt-4'}>
        <Link
          href={forgotUrl}
          className="hover:underline font-semibold underline text-sm text-gray-700"
          target="_blank"
          data-cy="forgot-password-link"
        >
          Forgot Password?
        </Link>
      </div>
    </form>
  );
};

export default EmailPasswordSignInForm;
